import { State } from '../state';

export const ManageAlarmsSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    filtersData: (state: State) => state.ManageAlarms,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectedDevice: (state: State) => state.ManageAlarms.selectedDevice,
};
